type PopulateFaqProps = {
  question: string;
  answer: string;
  id: string;
};
export const FaqData = (): PopulateFaqProps[] => {
  return [
    {
      question: 'What is eSwarna digital gold?',
      answer:
        'eSwarna Digital gold is a form of electronic money based on mass units of gold. It is a kind of representative money, like a US paper gold certificate at the time that these were exchangeable for gold on demand',
      id: 'question_1',
    },
    {
      question: 'Why should I buy Muthoot FinCorp ONE eSwarna Digital Gold?',
      answer:
        'eSwarna Digital gold is a form of electronic money based on mass units of gold. It is a kind of representative money, like a US paper gold certificate at the time that these were exchangeable for gold on demand',
      id: 'question_2',
    },
    {
      question: 'How to buy Muthoot FinCorp ONE eSwarna Digital Gold?',
      answer:
        'eSwarna Digital gold is a form of electronic money based on mass units of gold. It is a kind of representative money, like a US paper gold certificate at the time that these were exchangeable for gold on demand',
      id: 'question_3',
    },
    {
      question: 'How do I sell my gold?',
      answer:
        'eSwarna Digital gold is a form of electronic money based on mass units of gold. It is a kind of representative money, like a US paper gold certificate at the time that these were exchangeable for gold on demand',
      id: 'question_4',
    },
    {
      question:
        'How can I exchange my eSwarna Digital Gold for Physical Jewellery?',
      answer:
        'eSwarna Digital gold is a form of electronic money based on mass units of gold. It is a kind of representative money, like a US paper gold certificate at the time that these were exchangeable for gold on demand',
      id: 'question_5',
    },
    {
      question: 'Why is the buy and sell price different on the same day?',
      answer:
        'eSwarna Digital gold is a form of electronic money based on mass units of gold. It is a kind of representative money, like a US paper gold certificate at the time that these were exchangeable for gold on demand',
      id: 'question_6',
    },
  ];
};

export const preloginDqFaqs = (): PopulateFaqProps[] => {
  return [
    {
      question: 'What is eSwarna Digital Gold?',
      answer:
        'eSwarna Digital Gold is the virtual method of buying and investing in gold without having to physically hold the gold. When you buy eSwarna Digital Gold on Muthoot FinCorp ONE platform, the corresponding physical gold is stored at secure vaults by Muthoot EXIM appointed custodian Sequel Logistics completely free of cost.\n Your gold is always 100% safe and secure at no extra cost.',

      id: 'question_1',
    },
    {
      question: 'What is the Purity of Gold?',
      answer:
        'Muthoot EXIM offers 999 fineness also known as 24 karat purity through Muthoot FinCorp ONE platform.',

      id: 'question_2',
    },
    {
      question: 'How safe is my gold investment?',
      answer:
        'Your investment is 100% safe and secure with Muthoot EXIM. The physical gold is stored in secure vaults by Muthoot EXIM appointed custodian Sequel Logistics.',

      id: 'question_3',
    },
    {
      question:
        'What are the transaction charges applicable on eSwarna Digital Gold?',
      answer:
        'On every purchase transaction GST is payable at the applicable rate from time to time. No GST will be applicable for sale transactions.',
      id: 'question_4',
    },
    {
      question:
        'Can I convert my eSwarna Digital Gold to gold coins and/or jewellery?',
      answer:
        'Yes, you can encash the gold purchased on Muthoot FinCorp ONE platform any time after 24 working hours from the time of purchase. On the Option to convert eSwarna digital gold into jewellery or gold coins, we will be introducing the same soon.',
      id: 'question_5',
    },
    {
      question: 'How do I contact customer support for any issues?',
      answer: 'Please feel free to write to us at  customercare@muthoot.com',
      id: 'question_6',
    },
    {
      question:
        'In case of death of the customer, what happens to his/her eSwarna Digital Gold account?',
      answer:
        'In the event of a customer’s death, their legal heir can claim the gold by submitting necessary documents to establish his/her claim.  Muthoot FinCorp ONE after verification and if satisfied, will substitute the legal heir in place of the deceased customer.',
      id: 'question_7',
    },
    // {
    //   question:
    //     'What are the documents to be submitted by the legal heir to claim the ownership of the gold?',
    //   answer:
    //     '1.In case of death of the customer, what happens to his/her eSwarna Digital Gold account \n 2.Proof that the person is the legal heir of the account holder.',
    //   id: 'question_8',
    // },
    {
      question: 'At what price is gold sold/ bought from customers?',
      answer:
        'All Buy/Sell transactions on Muthoot FinCorp ONE are based on the live gold rate reflected on the app. This price is locked for 4 mins and 30 secs for the customer to complete the transaction. In case the transaction is not completed within the given time the system is refreshed with the live gold rate.',
      id: 'question_8',
    },
    {
      question:
        "What happens when payment is deducted through a customer's UPI account, but the gold is not credited in customers’ gold balance?",
      answer:
        'If any payment has been debited from your UPI account, and the gold is not credited in your Muthoot FinCorp ONE gold balance, an automatic refund will be initiated by us and the amount will be credited to your bank account within 3-5 working days. You may also contact our customer care team at customercare@muthoot.com   for any further queries or status updates.',
      id: 'question_9',
    },
    {
      question:
        'What is the payment method supported for eSwarna Digital Gold?',
      answer:
        'We support UPI as the payment method for transaction of eSwarna Digital Gold on Muthoot FinCorp ONE platform',
      id: 'question_10',
    },
  ];
};

export const rebrandedPreloginDqFaqs = (): PopulateFaqProps[] => {
  return [
    {
      question: 'What is eSwarna Digital Gold?',
      answer:
        'eSwarna Digital Gold is the virtual method of buying and investing in gold without having to physically hold the gold. When you buy eSwarna Digital Gold on Muthoot FinCorp ONE , the corresponding physical gold is stored at secure vaults by Muthoot EXIM appointed custodian Sequel Logistics completely free of cost. Your gold is always 100% safe and secure at no extra cost.',

      id: 'question_1',
    },
    {
      question: 'What is the Purity of Gold?',
      answer:
        'Muthoot EXIM offers 999 fineness also known as 24 karat purity through Muthoot FinCorp ONE platform.',

      id: 'question_2',
    },
    {
      question: 'How safe is my gold investment?',
      answer:
        'Your investment is 100% safe and secure with Muthoot EXIM. The physical gold is stored in secure vaults by Muthoot EXIM appointed custodian Sequel Logistics.',

      id: 'question_3',
    },
    {
      question:
        'What are the transaction charges applicable on eSwarna Digital Gold?',
      answer:
        'On every purchase transaction GST is payable at the applicable rate from time to time. No GST will be applicable for sale transactions.',
      id: 'question_4',
    },
    {
      question:
        'Can I convert my eSwarna Digital Gold to gold coins and/or jewellery?',
      answer:
        'Yes, you can encash the gold purchased on Muthoot FinCorp ONE platform any time after 24 working hours from the time of purchase. We will soon be introducing the option to convert eSwarna Digital Gold into jewellery or gold coins.',
      id: 'question_5',
    },
    {
      question: 'How do I contact customer support for any issues?',
      answer: 'Please feel free to write to us at customercare@muthoot.com',
      id: 'question_6',
    },
    {
      question:
        'In case of death of the customer, what happens to his/her eSwarna Digital Gold account?',
      answer:
        'In the event of a customer’s death, their legal heir can claim the gold by submitting necessary documents to establish his/her claim . Once their identity has been verified  we will substitute the legal heir in place of the deceased customer.',
      id: 'question_7',
    },
    // {
    //   question:
    //     'What are the documents to be submitted by the legal heir to claim the ownership of the gold?',
    //   answer:
    //     '1.In case of death of the customer, what happens to his/her Digital Gold account \n 2.Proof that the person is the legal heir of the account holder.',
    //   id: 'question_8',
    // },
    {
      question: 'At what price is gold sold/ bought from customers?',
      answer:
        'All Buy/Sell transactions on Muthoot FinCorp ONE are based on the live gold rate reflected on the app. This price is locked for 4 mins and 30 secs for the customer to complete the transaction. In case the transaction is not completed within the given time frame, the system is refreshed with the live gold rate.',
      id: 'question_8',
    },
    {
      question:
        "What happens when payment is deducted through a customer's UPI account, but the gold is not credited in customers’ gold balance?",
      answer:
        'If any payment has been debited from your UPI account, and the gold has not credited to your gold balance, an automatic refund will be initiated by us, and the amount will be credited to your bank account within 3-5 working days. For further queries you may also contact our customer care team at customercare@muthoot.com.',
      id: 'question_9',
    },
    {
      question:
        'What is the payment method supported for eSwarna Digital Gold?',
      answer:
        'We support UPI as the payment method for the transaction of eSwarna Digital Gold on Muthoot FinCorp ONE.',
      id: 'question_10',
    },
  ];
};

export const BuySellFaqData = (): PopulateFaqProps[] => {
  return [
    {
      question: 'How much gold can I buy?',
      answer:
        'You can buy gold up to Rs. 1,90,000 (one lakh ninety thousand only) in tranches or in aggregate without KYC in a financial year. With KYC compliance, there is no upper cap on buying gold.',
      id: 'question_1',
    },
    {
      question:
        'What is the minimum and maximum amount needed to buy gold on Muthoot FinCorp ONE?',
      answer:
        'The minimum amount of purchase is Re.1. There is no limit on the maximum amount subject to KYC criteria. In case of SIP, a customer can invest a minimum amount of Rs. 10 and a maximum amount of Rs. 5,000 on a single SIP.',
      id: 'question_2',
    },
    {
      question: 'How can I get my transaction receipt?',
      answer:
        'An online receipt for every Buy/Sell transaction can be downloaded from the order details page. The customer will also receive a SMS and email notification with a link to download the receipt after each successful transaction.',
      id: 'question_3',
    },
    {
      question: 'At what price is gold sold/ bought from customers',
      answer:
        'All Buy/Sell transactions on Muthoot FinCorp ONE are based on the live gold rate reflected on the app. This price is locked for 4 mins and 30 secs for the customer to complete the transaction. In case the transaction is not completed within the given time the system is refreshed with the live gold rate.',
      id: 'question_4',
    },
    {
      question: 'Is my gold insured and safe?',
      answer:
        'Yes, your gold is safe through Muthoot Exim’s comprehensive insurance policy and secured in vaults by Muthoot EXIM appointed custodian Sequel Logistics completely free of cost.',
      id: 'question_5',
    },
    {
      question:
        'What is the lock- in period to sell my eSwarna digital gold after purchase?',
      answer:
        'You can sell your gold after 1 working day of the purchase transaction.',
      id: 'question_6',
    },
    {
      question:
        'Can someone else redeem my Digital/physical gold on my behalf?',
      answer:
        'Only in the event of a customer’s death, their legal heir will be able to collect the gold coin, jewellery or encash it via Sell transaction. This can be done only after submitting their proof of identity along with the original / notarized copy of the customer’s death certificate and proof that the person is the legal heir of the account holder.',
      id: 'question_7',
    },
    {
      question:
        'When I sell my Gold, how soon will I get the funds credited to my account?',
      answer:
        "Once the Ssale transaction is successful on Muthoot FinCorp ONE platform, the funds will be instantly credited to the customer's bank account. However, if there is any technical glitch or any operational challenge at the bank’s end, Muthoot FinCorp ONE will credit the customer’s bank account within 03 working days. ",
      id: 'question_8',
    },
    {
      question: 'Is it mandatory to do KYC while selling of gold',
      answer: 'For any sale transaction, KYC is mandatory. ',
      id: 'question_9',
    },
    {
      question: 'Is it mandatory to do KYC for Buy transaction?',
      answer:
        'The customer must complete the KYC for the following Buy transactions:1.Whenever the overall eSwarna Digital Gold holdings on Muthoot FinCorp ONE exceed INR 1,90,000.2.Whenever the cumulative SIP amount exceeds INR 20,000.',
      id: 'question_10',
    },
    {
      question: 'What are the required KYC documents?',
      answer:
        'The following documents are mandatory for KYC – 1.PAN card  2.Aadhaar card 3. Liveliness check',
      id: 'question_11',
    },
    {
      question:
        'What is the duration of the Live Price freeze, and what is included in it?',
      answer:
        'The live gold price once frozen, is valid for only 4 minutes and 30 seconds. This includes the time taken to complete the entire eSwarna Digital Gold transaction, right from selection of order value to the final payment. Please complete your transaction within this time.',
      id: 'question_12',
    },

    {
      question:
        'What is the role of Muthoot Exim Pvt. Ltd. in relation to eSwarna Digital Gold?',
      answer:
        'eSwarna Digital Gold offered on Muthoot FinCorp ONE is provided by Muthoot Exim Pvt. Ltd. Kindly note that all service-related queries and grievances for eSwarna Digital Gold will be addressed by Muthoot Exim Pvt. Ltd.',
      id: 'question_13',
    },
  ];
};
